const Faq = () => {
    const faqItems = document.querySelectorAll('.faq__category-items-item-top');

    if(faqItems) {
        faqItems.forEach(item => {
            item.addEventListener('click', function () {
                const content = this.nextElementSibling;
                const icon = this.querySelector('.faq__category-items-item-top-icon');
    
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                    icon.classList.remove('open');
                } else {
                    document.querySelectorAll('.faq__category-items-item-top-value').forEach(value => value.style.maxHeight = null);
                    document.querySelectorAll('.faq__category-items-item-top-icon').forEach(icn => icn.classList.remove('open'));
    
                    content.style.maxHeight = content.scrollHeight + "px";
                    icon.classList.add('open');
                }
            });
        });
    }

    const faqItemsSingle = document.querySelectorAll('.faq-tab');

    if(faqItemsSingle) {
        faqItemsSingle.forEach(item => {
            item.addEventListener('click', function () {
                const content = this.querySelector('.tab-content p');
                const icon = this.querySelector('.ez-toc-section-end');
    
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                    icon.classList.remove('open');
                } else {
                    document.querySelectorAll('.tab-content p').forEach(value => value.style.maxHeight = null);
                    document.querySelectorAll('.ez-toc-section-end').forEach(icn => icn.classList.remove('open'));
    
                    content.style.maxHeight = content.scrollHeight + "px";
                    icon.classList.add('open');
                }
            });
        });
    }
}

export default Faq;